import React from "react";

const Community = () => {
  return (
    <div>
      <h1>Community</h1>
      <p>Welcome to the Community page.</p>
    </div>
  );
};

export default Community;
